const state = {
  productsBatch: [],
};

const mutations = {
  SET_BATCH(state, products) {
    state.productsBatch = products || [];
  },
  ADD_PRODUCT(state, product) {
    const idx = state.productsBatch.findIndex(p => p.id === product.id);
    if (idx === -1) state.productsBatch.push(product);
    else state.productsBatch.splice(idx, 1, product);
  },
  REMOVE_PRODUCT(state, productId) {
    state.productsBatch = state.productsBatch.filter(p => p.id !== productId);
  },
  CLEAR_BATCH(state) {
    state.productsBatch = [];
  }
};

const actions = {
  setBatch({ commit }, products) {
    commit('SET_BATCH', products);
  },
  addProduct({ commit, state }, product) {
    console.log(state);
    
    commit('ADD_PRODUCT', product);
  },
  removeProduct({ commit }, productId) {
    commit('REMOVE_PRODUCT', productId);
  },
  clearBatch({ commit }) {
    commit('CLEAR_BATCH');
  },
  toggleProduct({ commit, state }, product) {
    const exists = state.productsBatch.some(p => p.id === product.id);
    if (exists) commit('REMOVE_PRODUCT', product.id);
    else commit('ADD_PRODUCT', product);
  }
};

const getters = {
  productsBatch: state => state.productsBatch,
  batchCount: state => state.productsBatch.length,
  totalPrice: state => state.productsBatch.reduce((sum, p) => sum + (parseFloat(p.price) || 0), 0),
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
